import { lazy } from "react";
import { Route, Router, Switch } from "wouter";

import MainLayout from "@/shared/components/MainLayout";
import NotFoundPage from "@/shared/components/NotFoundPage";

import AdminAuthGuard from "@/features/admin/components/AdminAuthGuard";
import AdminLayout from "@/features/admin/components/AdminLayout";

const Wizard = lazy(() => import("@/features/wizard/WizardFeature"));
const AdminLogin = lazy(() => import("@/features/admin/pages/AdminLoginPage"));
const Admin = lazy(() => import("@/features/admin/pages/AdminDashboardPage"));
const AdminQueueJobs = lazy(
  () => import("@/features/admin/pages/AdminQueueJobsPage"),
);
const AdminDataArchives = lazy(
  () => import("@/features/admin/pages/AdminDataArchivesPage"),
);
const AdminPrintQueue = lazy(
  () => import("@/features/admin/pages/AdminPrintQueuePage"),
);
const AdminPrintLogs = lazy(
  () => import("@/features/admin/pages/AdminPrintLogsPage"),
);
const AdminComposites = lazy(
  () => import("@/features/admin/pages/AdminCompositesPage"),
);
const AdminTestGemini = lazy(
  () => import("@/features/admin/pages/AdminTestGeminiPage"),
);
const AdminConfigs = lazy(
  () => import("@/features/admin/pages/AdminConfigsPage"),
);
const AdminConfigValue = lazy(
  () => import("@/features/admin/pages/AdminConfigValuePage"),
);
const AdminConfigSchema = lazy(
  () => import("@/features/admin/pages/AdminConfigSchemaPage"),
);
const AdminStats = lazy(() => import("@/features/admin/pages/AdminStatsPage"));
const PhotoView = lazy(() => import("@/features/wizard/pages/PhotoViewPage"));
const SocialWall = lazy(
  () => import("@/features/social-wall/pages/SocialWallPage"),
);

export default function Routes() {
  return (
    <Router>
      <Switch>
        <Route path="/admin" nest>
          <Switch>
            <Route path="/login" component={AdminLogin} />
            <Route path={/(?!\/$)/} nest>
              <AdminLayout>
                <AdminAuthGuard>
                  <Switch>
                    <Route path="/" component={Admin} />
                    <Route path="/queue-jobs" component={AdminQueueJobs} />
                    <Route
                      path="/data-archives"
                      component={AdminDataArchives}
                    />
                    <Route path="/print-queue" component={AdminPrintQueue} />
                    <Route path="/print-logs" component={AdminPrintLogs} />
                    <Route path="/composites" component={AdminComposites} />
                    <Route path="/test-gemini" component={AdminTestGemini} />
                    <Route path="/configs" component={AdminConfigs} />
                    <Route path="/stats" component={AdminStats} />
                    <Route
                      path="/config/:key/value"
                      component={AdminConfigValue}
                    />
                    <Route
                      path="/config/:key/schema"
                      component={AdminConfigSchema}
                    />
                  </Switch>
                </AdminAuthGuard>
              </AdminLayout>
            </Route>
          </Switch>
        </Route>
        <Route path="/" nest>
          <MainLayout>
            <Switch>
              <Route
                path={
                  /^\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/i
                }
                component={PhotoView}
              />
              <Route path="/social-wall" component={SocialWall} />
              <Route path="/form" component={Wizard} />
              <Route component={NotFoundPage} />
            </Switch>
          </MainLayout>
        </Route>
        <Route component={NotFoundPage} />
      </Switch>
    </Router>
  );
}
